"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginCodeInput = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var form_1 = require("../../form");
var LoginCodeInput = function (_a) {
    var code = _a.code;
    return (0, jsx_runtime_1.jsx)(form_1.SecondaryButton, { value: code }, void 0);
};
exports.LoginCodeInput = LoginCodeInput;
exports.default = exports.LoginCodeInput;
